import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InfoModalComponent } from 'app/modules/cdft/components/info-modal/info-modal.component';
import { Location } from '@angular/common';
import { StringEquipmentState } from 'app/modules/cdft/state/string-equipment.state';
import { WellStringStatusState } from 'app/modules/cdft/state/well-string-status.state';
import { clearAll } from 'app/core/state/helper';
import { CDFTService } from 'app/modules/cdft/services/cdft.service';
import { CDFTState } from 'app/modules/cdft/state/cdft.state';
import { ActivatedRoute } from '@angular/router';
import { CdftStatus } from 'app/modules/cdft/model';
import module from 'app/modules/cdft/cdft.module';
import { toast } from 'ngx-sonner';
import { CDFTSyncNotificationService } from 'app/modules/cdft/services/cdft-sync-notification.service';
import { Subject, takeUntil } from 'rxjs';
import { ReviewModalComponent } from '../../components/review-modal/review-modal.component';

@Component({
    selector: 'app-cdft-edit',
    templateUrl: './edit.page.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./edit.page.scss'],
})
export class CDFTEditPage implements OnInit, OnDestroy {
    panelOpenState = false;
    isloading: boolean = false;
    status = CdftStatus;
    isInputError: boolean = false;
    isPendingSync: boolean = false;
    private readonly destroy$ = new Subject<void>();

    get isNotReady(): boolean {
        return (
            this.state._formGroup.detail.get('status').value !=
            this.status.READY
        );
    }

    get showWfamStatus(): boolean {
        return (
            !this.isloading &&
            this.state._formGroup.detail.get('status').value !=
            this.status.DRAFT
        );
    }

    protected readonly toast = toast;
    constructor(
        private dialog: MatDialog,
        public location: Location,
        private stringEquipmentState: StringEquipmentState,
        private wellStringStatusState: WellStringStatusState,
        private service: CDFTService,
        public state: CDFTState,
        private route: ActivatedRoute,
        private readonly syncNotificationService: CDFTSyncNotificationService,
    ) { }

    ngOnInit() {
        this.isloading = true;
        clearAll([
            this.stringEquipmentState,
            this.wellStringStatusState,
            this.state,
        ]);
        this.service.getValveOptionType().subscribe(() => {
            const id = this.route.snapshot.paramMap.get('id');
            this.service.getCdft(id).subscribe(() => (this.isloading = false));
        });

        this.service.cdftErrors$.subscribe((err) => {
            if (err) this.isInputError = true;
        });

        const id = this.route.snapshot.paramMap.get('id');
        this.syncNotificationService.syncNotifications$
            .pipe(takeUntil(this.destroy$))
            .subscribe((notifications) => {
                const pendingNotification = notifications.find(
                    (n) =>
                        n.cdftId === id &&
                        n.payload?.status === this.status.READY,
                );
                this.isPendingSync = !!pendingNotification;
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public openInfo() {
        this.dialog.open(InfoModalComponent, {
            width: '70%',
        });
    }

    save(status = null) {
        const headerGroup = this.state._formGroup.cdftHeader;

        if (!headerGroup?.valid ||
            !headerGroup.get('date')?.value) {
            this.toast.error('Date in the Header Information is empty');
            return;
        }

        if (status) this.state.status = status;
        this.state.recalculate();
        const payload = this.state.toPayload();

        // Get plain object for offline cache since FormData cannot be stored/retrieved easily from IndexedDB
        const cachePayload = this.state.toPayloadObject();
        this.service.updateCdft(payload, cachePayload).subscribe({
            next: (response) => {
                this.ngOnInit();
            },
        });
    }

    disabledSubmit(): boolean {
        return !this.state.result || this.state.result == '-';
    }
}
